"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M11.9167 4.75C11.9167 6.95914 10.1259 8.75 7.91675 8.75C5.70761 8.75 3.91675 6.95914 3.91675 4.75C3.91675 2.54086 5.70761 0.75 7.91675 0.75C10.1259 0.75 11.9167 2.54086 11.9167 4.75Z",
      stroke: "currentColor",
      strokeWidth: "1.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M0.75 16.3606C0.75 15.6801 1.23385 14.5554 2.43033 13.5731C3.59845 12.6141 5.40644 11.8333 7.91667 11.8333C10.4269 11.8333 12.2349 12.6141 13.403 13.5731C14.5995 14.5554 15.0833 15.6801 15.0833 16.3606V17.4167C15.0833 17.6377 14.9955 17.8496 14.8393 18.0059C14.683 18.1622 14.471 18.25 14.25 18.25H1.58333C1.36232 18.25 1.15036 18.1622 0.994078 18.0059C0.837797 17.8496 0.75 17.6377 0.75 17.4167V16.3606Z",
      stroke: "currentColor",
      strokeWidth: "1.5"
    })]
  });
};

exports.default = Icon;